<template>
  <div class="bg-white shadow-sm pt-2 pb-3 " style="border-radius: 20px;">
    <div class="d-flex align-items-center">
      <div class="px-4 d-flex align-items-center پml-auto">
        <div class="p-2 ml-auto">آمار ماهانه</div>
      </div>
    </div>
    <hr>
    <div id="chart"  style="filter: blur(5px);">
    </div>
    <div class="locked-overlay" v-if="status == 'loading'">
      <div style="position: absolute; width: 100%; text-align: center; top: 30%;">
        <div class="btn btn-success mt-5">
          <div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>
        </div>
      </div>
    </div>
    <div class="locked-overlay" v-else-if="status == 'success'">
      <div style="position: absolute; width: 100%; text-align: center; top: 30%;">
        <div>
          <div class="btn">
            <img src="@/assets/new/image/not-found_new.png" width="200">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'

export default {
  name: "chart",
  props : ['status'],
  mounted() {
    var options = {
      chart: {
        height: 350,
        type: "line",
        stacked: false,

      },
      dataLabels: {
        enabled: false
      },
      colors: ["#00bea5", "#fe0202"],
      series: [
        {
          name: "مبلغ",
          data: [10, 5, 0, 1, 3, 0, 1, 2, 6, 2, 3, 6, 3, 2, 3, 2, 6, 2, 3, 4, 0, 3, 1, 2, 3, 2, 4, 2, 0, 1]
        },
      ],
      stroke: {
        curve: 'smooth',
        width: 3
      },
      yaxis: {
        labels: {
          show: false
        }
      }

    };

    var chart = new ApexCharts(document.querySelector("#chart"), options);

    chart.render();
  },
}
</script>

<style>
#chart {
  max-width: 700px;
  max-height: 200px;
  margin: auto;
}
</style>